import React from "react";
import { Box, Typography, TextField, Select, MenuItem, FormControl } from "@mui/material";
import { useTranslation } from "react-i18next";

const PublicInfoCard = ({ title, fields, onFieldChange }) => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language === "ar";

  return (
    <Box className="info-card mb-4 shadow-sm" sx={{ borderRadius: "12px", overflow: "hidden" }}>
      {title && (
        <div className="info-card-header" style={{ padding: "15px", backgroundColor: "#f8f9fa" }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: "#495057" }}>
            {title}
          </Typography>
        </div>
      )}
      <Box className="info-card-body" sx={{ p: 3 }}>
        <div className="row">
          {fields.map((field, index) => (
            <div className="col-12 mb-4" key={field.key || index}>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 1, fontWeight: 500 }}>
                {field.label} {field.required && <span className="text-danger">*</span>}
              </Typography>
              
              {field.type === "select" ? (
                <FormControl fullWidth size="small">
                  <Select
                    value={field.value || ""}
                    onChange={(e) => {
                      // Use field.onChange if provided, otherwise use onFieldChange
                      if (field.onChange) {
                        field.onChange(e.target.value);
                      } else {
                        onFieldChange(field.key, e.target.value);
                      }
                    }}
                    onBlur={field.onBlur}
                    disabled={field.disabled}
                    displayEmpty
                    error={!!field.error}
                    sx={{
                      borderRadius: "8px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "8px !important",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "8px !important",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "8px !important",
                      },
                      "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "8px !important",
                      },
                      ...(field.disabled && {
                        backgroundColor: "#f5f5f5",
                        borderRadius: "8px !important",
                        "& .MuiSelect-select": {
                          color: "#9e9e9e",
                          borderRadius: "8px !important"
                        }
                      })
                    }}
                  >
                    <MenuItem value="" disabled>
                      {isAr ? "اختر..." : "Select..."}
                    </MenuItem>
                    {field.options?.map((opt, i) => (
                      <MenuItem key={opt.id || opt.value || i} value={opt.id || opt.value}>
                        {field.key && field.key.includes("country")
                          ? t(`countries.${opt.value}`, { defaultValue: opt.name || opt.label })
                          : (opt.name || opt.label)
                        }
                      </MenuItem>
                    ))}
                  </Select>
                  {field.error && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
                      {field.error}
                    </Typography>
                  )}
                </FormControl>
              ) : (
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  type={field.type || "text"}
                  value={field.value || ""}
                  onChange={(e) => {
                    // Use field.onChange if provided, otherwise use onFieldChange
                    if (field.onChange) {
                      field.onChange(e.target.value);
                    } else {
                      onFieldChange(field.key, e.target.value);
                    }
                  }}
                  onBlur={field.onBlur}
                  disabled={field.disabled}
                  placeholder={field.placeholder || field.label}
                  error={!!field.error}
                  helperText={field.error}
                  InputLabelProps={
                    field.type === "date" ? { shrink: true } : undefined
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "8px !important",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "8px !important",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "8px !important",
                      },
                      
                      "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "8px !important",
                      }
                    },
                    "& .MuiOutlinedInput-input": {
                      borderRadius: "8px",
                      
                      "&.Mui-disabled": {
                        borderRadius: "8px",
                      }
                    },
                    ...(field.disabled && {
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#f5f5f5",
                        borderRadius: "8px",
                        "& input": {
                          color: "#9e9e9e",
                          WebkitTextFillColor: "#9e9e9e"
                        }
                      }
                    })
                  }}
                />
              )}
            </div>
          ))}
        </div>
      </Box>
    </Box>
  );
};

export default PublicInfoCard;